{ "id": "bouftou", "name": "Bouftou", "sprite": "bouftou", "hp": 46, "speed": 135, "radius": 22, "contactDamage": { "element": "terre", "min": 6, "max": 9 }, "attackCooldown": 0.8, "xp": 10, "kamas": [2, 5], "resistances": {} }
